class DateTimeHelper {
  static formatDate(date) {
    const d = new Date(date);
    return d
      ? ("0" + d.getDate()).slice(-2) +
      "." +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "." +
      d.getFullYear() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2)
      : "-";
  }
}

export default DateTimeHelper;
